import { getArea as OlGetArea, getLength as OlGetLength } from 'ol/sphere';
import { FEEDBACKS_GEOMETRY_TYPE_CODES, FEEDBACKS_GEOMETRY_TYPES } from '../../constants';
export function getLocationString(feature, importMode) {
    if (!feature) {
        return '';
    }
    return getLocationStringFromCoordinates(feature.getGeometry().getCoordinates(), feature.getGeometry().getType(), undefined, importMode);
}
export function getLocationStringFromCoordinates(coordinates, locationType, closePolygon = true, importMode = false) {
    let location = '';
    const seperatiorPoint = !importMode ? ',' : ' ';
    const seperatiorItem = !importMode ? ' ' : ',';

    if (locationType === 'MultiPolygon') {
        coordinates = coordinates[0];
    }

    for (const coord of coordinates) {
        switch (locationType) {
            case 'Point':
                if (location > 0) {
                    location += seperatiorPoint;
                }
                location += coord;
                break;
            case 'LineString':
                location += `${coord.join(seperatiorPoint)}${seperatiorItem}`;
                break;
            case 'MultiPolygon':
            case 'Polygon':
                coord.forEach(([point1, point2]) => {
                    location += `${[point1, point2].join(seperatiorPoint)}${seperatiorItem}`;
                });
                if (closePolygon) {
                    location = closePolygonString(location, importMode);
                }
                break;
            default:
                // Unknown geometrytype
                break;
        }
    }
    // returns value without the last seperator character, if necessary
    return location.endsWith(seperatiorItem) ? location.slice(0, -1) : location;
}
export function closePolygonString(location, importMode = false) {
    const seperatiorPoint = !importMode ? ',' : ' ';
    const seperatiorItem = !importMode ? ' ' : ',';
    const splitCoords = location.split(seperatiorItem).filter(coord => coord !== '');
    const firstCoord = splitCoords[0].split(seperatiorPoint);
    const lastCoord = splitCoords[splitCoords.length - 1].split(seperatiorPoint);
    if (firstCoord[0] !== lastCoord[0] || firstCoord[1] !== lastCoord[1]) {
        return `${location}${seperatiorItem}${firstCoord[0]}${seperatiorPoint}${firstCoord[1]}`;
    } else {
        return location;
    }
}
/**
 * Create an array with arrays of xy coordinate pairs
 * @param {string} location The coordinates as a string
 * @return {string} array with coordinates
 */
export function createPointArray(location) {
    return location.split(' ').map(coordXY => coordXY.split(',').map(parseFloat));
}
export function getFeedbackGeometryType(type) {
    if (type.includes(FEEDBACKS_GEOMETRY_TYPE_CODES.LINE)) {
        return FEEDBACKS_GEOMETRY_TYPES.LINE;
    }
    if (type.includes(FEEDBACKS_GEOMETRY_TYPE_CODES.POLYGON)) {
        return FEEDBACKS_GEOMETRY_TYPES.POLYGON;
    }
    if (type.includes(FEEDBACKS_GEOMETRY_TYPE_CODES.POINT)) {
        return FEEDBACKS_GEOMETRY_TYPES.POINT;
    }
    return FEEDBACKS_GEOMETRY_TYPES.POLYGON;
}
export function getMeasureTotals(drawObject, isPoint) {
    // if there are no points we can return null values
    if (!drawObject?.points) {
        return  {
            length: null,
            coord_x: null,
            coord_y: null,
            area: null
        };
    }
    const { length, area } = drawObject;
    const [cx, cy] = drawObject?.coordinates ?? [null, null];
    return {
        length,
        coord_x: isPoint && cx ? cx.toFixed(2) : null,
        coord_y: isPoint && cy ? cy.toFixed(2) : null,
        area
    };
}

export function getFeatureMeasureTotals(geometry, isPoint) {
    if (!geometry) {
        return {
            length: null,
            coord_x: null,
            coord_y: null,
            area: null
        };
    }
    let length = null;
    let area = null;
    let coord_x = null;
    let coord_y = null;
    if (isPoint) {
        const [cx, cy] = geometry.getCoordinates();
        coord_x = cx ? cx.toFixed(2) : null;
        coord_y = cy ? cy.toFixed(2) : null;
    } else {
        area = Math.round(OlGetArea(geometry) * 100) / 100;
        length = Math.round(OlGetLength(geometry) * 100) / 100;
    }
    return {
        length,
        area,
        coord_x,
        coord_y
    };
}
